import React from 'react';
import PropTypes from 'prop-types';
import DisplayTemplate from './DisplayTemplate';
import EditTemplate from './EditTemplate';

const propTypes = {
    children: PropTypes.arrayOf(
        PropTypes.oneOfType([
            PropTypes.objectOf(DisplayTemplate),
            PropTypes.objectOf(EditTemplate)
        ])
    ).isRequired,
    mode: PropTypes.string,
    id: PropTypes.string,
    label: PropTypes.string
};

const defaultProps = {
    mode: "display",
    id: "editable-content"
};

export class EditableWrapper extends React.PureComponent {
    render() {
        let childComponents = null;
        switch (this.props.mode) {
            case "display":
                childComponents = this.props.children[0];
                break;
            case "edit":
                childComponents = this.props.children[1];
                break;
            default:
                childComponents = null;
        }

        const children = this.props.label ? (
            React.Children.map(childComponents, (child) =>
                React.cloneElement(child, { label: this.props.label })
            )
        ) : childComponents;

        return (
            <div
                role="region"
                id={this.props.id}
                tabIndex="-1"
                aria-labelledby={this.props.id ? `${this.props.id}-heading` : 'editable-content-heading'}>
                <div
                    className="rec-sr-only"
                    id={this.props.id ? `${this.props.id}-heading` : 'editable-content-heading'}>
                    {this.props.label ? this.props.label : 'Editable Content'}
                </div>
                {children}
            </div>
        );
    }
}

EditableWrapper.propTypes = propTypes;
EditableWrapper.defaultProps = defaultProps;

export default EditableWrapper;
